import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Buildings, ArrowRight } from "@phosphor-icons/react";
import { useAuth } from "@/contexts/AuthContext";

// Self-serve academy creation has been retired — academies are now provisioned
// by the platform admin (Super Admin → Academies). Super admins are sent there;
// everyone else sees how to request one.
export default function AcademyNew() {
  const nav = useNavigate();
  const { user } = useAuth();
  const isSuperAdmin = user?.role === "super_admin";

  useEffect(() => {
    if (isSuperAdmin) nav("/admin?tab=academies", { replace: true });
  }, [isSuperAdmin, nav]);

  if (isSuperAdmin) return null;

  return (
    <div className="max-w-2xl mx-auto p-6 lg:p-10" data-testid="academy-new-page">
      <div className="tactical-card p-8 text-center">
        <Buildings size={36} className="text-brand-accent mx-auto mb-4" weight="duotone" />
        <div className="label-tiny text-brand-accent tracking-widest mb-2">// ACADEMIES</div>
        <h1 className="font-heading text-3xl sm:text-4xl mb-3">SET UP BY OUR TEAM</h1>
        <p className="text-text-secondary text-sm max-w-lg mx-auto mb-6">
          Academies are provisioned by the Edge Training team. Want to bring your gym, club or team
          of coaches under one roof? Get in touch and we&apos;ll create your academy and invite you
          as its admin — then you can invite your coaches and athletes.
        </p>
        <a
          href="mailto:admin@edgetraining.com?subject=Set%20up%20my%20academy"
          className="inline-flex items-center gap-2 btn-kinetic px-5 py-2.5 text-sm label-tiny tracking-wider"
          data-testid="academy-request-contact"
        >
          REQUEST AN ACADEMY <ArrowRight size={14} weight="bold" />
        </a>
      </div>
    </div>
  );
}
